import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APIURL } from "./config";
import axios from "axios";

const LicenseGuard = ({ children }) => {
  const [isLicenseValid, setIsLicenseValid] = useState(null); // Track license status
  const navigate = useNavigate();

  useEffect(() => {
    // Check license status from your backend API
    const checkLicenseStatus = async () => {
      try {
        const response = await axios.post(
          `${APIURL}/api/v1/license/check-status`
        );
        
        if (response.status && response.status === 201 ) {
          setIsLicenseValid(true); // License is valid
        } else {
          setIsLicenseValid(false); // License is invalid
        }
      } catch (error) {
        console.error("Error checking license:", error);
        setIsLicenseValid(false);
      }
    };

    checkLicenseStatus();
  }, []);

  useEffect(() => {
    // Redirect to an appropriate page if the license is invalid
    if (isLicenseValid === false) {
      navigate("/license-error"); // Redirect to a custom error page
    }
  }, [isLicenseValid, navigate]);

  // Wait for license status to be determined
  if (isLicenseValid === null) {
    return (
      <div className="main-area">
        <div id="cover-spin"></div>
      </div>
    );
  }

  // Render the children if the license is valid
  return isLicenseValid ? children : null;
};

export default LicenseGuard;
